import React, {ReactNode} from 'react';

import {InlineBannerType} from 'ui-library/banners/InlineBanner';
import InlineBannerStack from 'ui-library/banners/InlineBannerStack';

export interface ValidationMessage {
  title: ReactNode;
  body: ReactNode;
}

const ValidationBanners = ({
  validationMessages,
  setValidationMessages,
}: {
  validationMessages: Array<ValidationMessage>;
  setValidationMessages: React.Dispatch<React.SetStateAction<Array<ValidationMessage>>>;
}): JSX.Element => (
  <InlineBannerStack
    messages={validationMessages.map((message) => ({
      bannerType: InlineBannerType.ERROR,
      text: message.title,
      supportingInfo: message.body,
      onDismiss: () => {
        setValidationMessages(validationMessages.filter((msg) => msg !== message));
      },
    }))}
  />
);

export default ValidationBanners;
